import { createLogic } from 'redux-logic';
import ActionConstants from '../constants/actions';
import ApiConstants from '../constants/apiConstants';
import http from '../utils/http';

const UsersActions = [];

export default UsersActions;